<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center mb-4">
    <h2 class="text-left h3-tipografia-govco mb-0">
      {{ 'alertas-plataforma.titulo' | translate }}
    </h2>
  </div>

  <div class="mb-4">
    <label for="alertas-select" class="form-label">{{
      'alertas-plataforma.seleccione' | translate
    }}</label>
    <select
      id="alertas-select"
      class="form-select"
      [(ngModel)]="selectedAlertaId"
      (change)="onAlertaChange()">
      <option *ngFor="let alerta of alertas" [value]="alerta.Id">
        {{ alerta.Alerta }}
      </option>
    </select>

    <p class="variables-parrafo-alerta" *ngIf="variablesArray.length > 0">
      {{ 'alertas-plataforma.variables' | translate }}
      <span *ngIf="variablesArray.length > 0">
        {{ variablesArray.join(', ') }}
      </span>
    </p>
  </div>

  <div class="mb-4">
    <label for="detalle-alerta" class="form-label">{{
      'alertas-plataforma.detalle' | translate
    }}</label>
    <textarea
      id="detalle-alerta"
      class="form-control"
      rows="5"
      [(ngModel)]="editableDetalle"
      (input)="onDetalleEdit()"></textarea>
  </div>

  <button
    class="btn-govco fill-btn-govco"
    [disabled]="!detalleEditado"
    (click)="guardarCambios()"
    aria-label="Guardar cambios">
    {{ 'alertas-plataforma.guardar' | translate }}
  </button>
</div>
